import { BCMSCurrency } from "@bcm-dev/bcms-vite";
import "./styles.css";
/**
 * @function AccountSummaryTotalRow
 * @return {React.Component}
 * @exported true
 * @description A "bottom" row beneath account sections that show total amounts, like
 * available balance, current balance, and available credit.
 * This component is controlled by the following branding options:
 * 
 * (in abi22) Show Account Totals Above or Below sections in Account Summary widget (action script name: account_totals_above_or_below_abi22).
 * (in mabi23) Show Account Totals Above or Below sections in Account Summary widget (action script name: account_totals_above_or_below_mabi23).
 * (in abi22) Show Account Totals in Account Summary Widget (action script name: accttotals_acctsum_abi22).
 * (in mabi23) Show Account Totals in Account Summary Widget (action script name: accttotals_acctsum_mabi23).
 * 
 * If this row isn't shown, than an "above" row may be shown.
 */
export default function AccountSummaryTotalRow(props) {
  const hasTotalAccountBalancesOn = props.hasTotalAccountBalancesOn ?? false;
  const totalAccountBalancesObj = props.totalAccountBalancesObj ?? {};
  const showTotalAccountBalances = props.showTotalAccountBalances ?? true;
  const availableBalanceDataPoint = totalAccountBalancesObj.availableBalanceDataPoint ? { "data-point": totalAccountBalancesObj.availableBalanceDataPoint }: {};
  const availableCreditDataPoint = totalAccountBalancesObj.availableCreditDataPoint ? { "data-point": totalAccountBalancesObj.availableCreditDataPoint }: {};
  const currentBalanceDataPoint = totalAccountBalancesObj.currentBalanceDataPoint ? { "data-point": totalAccountBalancesObj.currentBalanceDataPoint }: {};
  const totalColumns = props.totalColumns ?? 2;

  const cell = obj => {
    let message = [];

    if(obj.availableBalance !== undefined) {
      message.push(
        <td className="text-right table-item-text-view">
          <span { ...availableBalanceDataPoint }>
            { BCMSCurrency.init(obj.availableBalance).format() }
          </span>
        </td>
      );
    }
    if(obj.availableCredit !== undefined) {
      message.push(
        <td className="text-right table-item-text-view">
          <span { ...availableCreditDataPoint }>
            { BCMSCurrency.init(obj.availableCredit).format() }
          </span>
        </td>
      );
    }
    if(obj.currentBalance !== undefined) {
      message.push(
        <td className="text-right table-item-text-view">
          <span { ...currentBalanceDataPoint }>
            { BCMSCurrency.init(obj.currentBalance).format() }
          </span>
        </td>
      );
    }

    return message;
  };
  
  let allCells = cell(totalAccountBalancesObj);
  if(!hasTotalAccountBalancesOn) return <></>;
  if(!showTotalAccountBalances) return <></>;

  let diff = totalColumns - allCells.length;

  // Sets the table cells in the row since it can vary due to the view are in and branding.
  for(let i = 0; i < diff; i++) {
    allCells = [ <td></td>, ...allCells ];
  }

  return (
    <tbody className="account-summary-total-row-container clickable">
      <tr className="table-item-container">
        { allCells }
      </tr>
    </tbody>
  );
}